import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import PageLayout from '@/components/layout/PageLayout';
import { TabList } from '@/components/ui/navigation/TabList';
import { useCheckInLocationPage } from '@/hooks/checkInLocation';
import { LocationListTab, AssignLocationTab, AssignedTab } from '@/components/features/checkInLocation';


export const CheckInLocationPage: React.FC = () => {
  const { t: translate } = useTranslation();
  const { activeTab, handleBackClick, handleTabChange } = useCheckInLocationPage();

  const tabs = useMemo(() => [
    {
      id: 'locations',
      label: translate('checkInLocation:tabs.locations'),
      content: <LocationListTab />,
    },
    {
      id: 'assignLocation',
      label: translate('checkInLocation:tabs.assignLocation'),
      content: <AssignLocationTab />,
    },
    {
      id: 'assigned',
      label: translate('checkInLocation:tabs.assigned'),
      content: <AssignedTab />,
    },
  ], [translate]);

  return (
    <PageLayout onBackClick={handleBackClick}>
      <div data-testid="check-in-location-page">
        <TabList
          tabs={tabs}
          defaultActiveTab={activeTab}
          onTabChange={handleTabChange}
        />
      </div>
    </PageLayout>
  );
};

export default CheckInLocationPage;
